import { NgModule } from '@angular/core';
import { NoPreloading, RouterModule, Routes } from '@angular/router';

//import { canActivate, redirectUnauthorizedTo, redirectLoggedInTo } from '@angular/fire/auth-guard';
//import { TokenPasswordComponent } from '@auth/pages/token-password/token-password.component';

import { StartComponent } from './layouts/main/pages/start/start.component';

//const redirectUnauthorized = () => redirectUnauthorizedTo(['auth']);
//const redirectLoggedIn = () => redirectLoggedInTo(['']);
// const belongsToAccount = (next) => hasCustomClaim(`account-${next.params.id}`);

const routes: Routes = [
  {
    path: '',
    //component: StartComponent,
    loadChildren: () => import('./layouts/main/main.module').then((m) => m.MainModule),
  },

  {
    path: 'system',
    loadChildren: () => import('./layouts/main/main.module').then((m) => m.MainModule),
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
